import * as ActionTypes from '~/actions/ActionTypes'
import * as ShowBlankProjectInList from '~/cookieServices/ShowBlankProjectInList'

/**
 * @param {boolean} saveEmpty
 */
export const hideBlankProjectFromList = () => async dispatch => {
  ShowBlankProjectInList.set(false)
  await dispatch({
    type: ActionTypes.PROJECTS_HIDE_BLANK_IN_LIST,
  })
}
